export const contactManagementVersion = '11.0.0';
